// extracted by mini-css-extract-plugin
module.exports = {"chatbot":"styles_chatbot__lORZA"};